import type { VolumeCard } from '../types/landing'

export const volumeCards: VolumeCard[] = [
  {
    id: 'volume-1',
    cover:
      'https://cdn.magicpatterns.com/uploads/5t66e8e5S9quukMMkKaYYr/02_volume_1_foundations_cover.png',
    coverAlt: 'Cover of Math Made Ready Volume 1 — Foundations',
    title: 'Volume 1 — Foundations',
    subtitle: 'Grades 1–2',
    copy:
      'Counting, addition, subtraction and place value challenges that build confidence from the start.',
    label: 'Answer keys included',
    accent: 'emerald',
  },
  {
    id: 'volume-2',
    cover:
      'https://cdn.magicpatterns.com/uploads/kdJqzA1eYysmVbfnuz5GeY/03_volume_2_builders_cover.png',
    coverAlt: 'Cover of Math Made Ready Volume 2 — Builders',
    title: 'Volume 2 — Builders',
    subtitle: 'Grade 3',
    copy:
      'Times tables, division and fractions presented through visual, game-ready challenges.',
    label: 'Answer keys included',
    accent: 'cyan',
  },
  {
    id: 'volume-3',
    cover:
      'https://cdn.magicpatterns.com/uploads/99zHypzUZMZ4uxiRzKUtnG/04_volume_3_masters_cover.png',
    coverAlt: 'Cover of Math Made Ready Volume 3 — Masters',
    title: 'Volume 3 — Masters',
    subtitle: 'Grades 4–5',
    copy:
      'Word problems, measurement and decimals for learners ready for more complex thinking.',
    label: 'Answer keys included',
    accent: 'emerald',
  },
  {
    id: 'bonus-pack',
    cover:
      'https://cdn.magicpatterns.com/uploads/oz2h1h5EivdsSZTDT2miCY/05_bonus_pack_cover.png',
    coverAlt: 'Cover of the Math Made Ready Bonus Pack',
    title: 'Bonus Pack',
    subtitle: 'Print, Cut and Celebrate',
    copy:
      'Progress tools, reward materials and printable extras that make practice easier to sustain.',
    accent: 'gold',
  },
]
